/**
* testimonial slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the testimonial slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'testimonial-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );

      $( '.testimonial-slider__slider' ).slick( {
        autoplay: false,
        arrows: true,
        centerMode: true,
        fade: true,
        dots: true,
        prevArrow: $( '.testimonial-slider-previous' ),
        nextArrow: $( '.testimonial-slider-next' ),
        slidesToScroll: 1,
        slidesToShow: 1,
        infinite: true,
        speed: 500,
      } );

      // $( '.testimonial-slider__testimonial-card-slide' ).slick( {
      //   autoplay: false,
      //   arrows: true,
      //   slidesToScroll: 1,
      //   slidesToShow: 1,
      //   infinite: true,
      //   responsive: [
      //     {
      //       breakpoint: 480,
      //       settings: {
      //         arrows: false,
      //         dots: false,
      //         centerPadding: '0px',
      //         slidesToShow: 1,
      //       },
      //     },
      //   ],
      // } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'testimonial-slider', COMPONENT );
} )( app );
